import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ChangePasswordRequest, QueryKey, UpdateProfileRequest, UserPublic } from 'api/model';
import { toast } from 'react-toastify';
import { changePassword, updateMe } from './requests';

const useProfile = () => {
  const queryClient = useQueryClient();

  const updateDisplayName = useMutation({
    mutationFn: (model: UpdateProfileRequest) => updateMe(model),
    onSuccess: (user: UserPublic) => {
      queryClient.setQueryData([QueryKey.CurrentUser], user);
      toast.success('Profile updated');
    },
  });

  const updatePassword = useMutation({
    mutationFn: (model: ChangePasswordRequest) => changePassword(model),
    onSuccess: () => toast.success('Password changed'),
  });

  return { updateDisplayName, updatePassword };
};

export default useProfile;
